import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Grid from "@mui/material/Grid2";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import { useCsAttribute } from "@plansoft-configuration-renderer/framework";
import { useConfigurationObjectScrolling } from "../../NavigationState/useConfigurationScrolling";
import { SubstructureAddButton } from "./SubstructureAddButton";
import { SubstructureElementLayout } from "./SubstructureElementLayout";
import { SubstructureInstanceButtons } from "./SubstructureInstanceButtons";
import { SubstructureLabel } from "./SubstructureLabel";
import { SubstructureScrollRestoreBehavior } from "./SubstructureScrollRestoreBehavior";
function SubstructureStubInstance({ substructure, }) {
    const elementRef = useConfigurationObjectScrolling({
        configurationObject: substructure,
    });
    return (_jsx(ListItem, { ref: elementRef, children: _jsxs(Grid, { container: true, alignItems: "center", width: "100%", children: [_jsxs(Grid, { size: { sm: 6 }, children: [_jsx(SubstructureLabel, { substructure: substructure }), _jsx(SubstructureScrollRestoreBehavior, { instancePath: substructure.path })] }), _jsx(Grid, { size: { sm: 6 }, children: _jsx(SubstructureInstanceButtons, { substructure: substructure }) })] }) }));
}
SubstructureStubInstance.displayName = "SubstructureStubInstance";
export function SubstructureStub() {
    var _a;
    const attribute = useCsAttribute();
    const substructures = (_a = attribute.configurations) !== null && _a !== void 0 ? _a : [];
    return (_jsx(SubstructureElementLayout, { addButton: _jsx(SubstructureAddButton, {}), instanceList: _jsx(List, { children: substructures.map((substructure, idx) => (_jsx(SubstructureStubInstance, { substructure: substructure }, idx))) }) }));
}
SubstructureStub.displayName = "SubstructureStub";
//# sourceMappingURL=SubstructureStub.js.map